import { CollectionProduct } from 'models/collection/collection';
import { useEffect } from 'react';
import { Gtm, gtm } from 'tracking/gtm';

type Input = {
  shouldTrigger?: boolean;
  products?: CollectionProduct[];
  collectionTitle: string;
};

/**
 * Tracking hook for collections in cdp, search results and fube
 */
const useCollectionReady = ({
  shouldTrigger = true,
  products,
  collectionTitle,
}: Input): void => {
  useEffect(() => {
    if (!shouldTrigger || !products || products.length === 0) {
      return;
    }

    const convertedProducts = products
      // Criteo tag only needs first three products
      .slice(0, 3)
      .map((x, idx) => ({
        productId: x.id,
        productType: x.productType,
        productTitle: x.title,
        tags: x.tags.join(','),
        list: collectionTitle || '',
        position: idx,
        variantId: x.variants[0].id,
      }));

    gtm({
      group: Gtm.GroupName.Collection,
      name: Gtm.CommonEventName.Ready,
      data: {
        products: convertedProducts,
      },
      nonInteractive: true,
    });
  }, [collectionTitle, products, shouldTrigger]);
};

export default useCollectionReady;
